var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemTasks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14 4a8 8 0 0 1 0 16 8 8 0 0 1-2-.262A8 8 0 0 1 10 20a8 8 0 0 1 0-16c.693 0 1.36.097 2 .263A8 8 0 0 1 14 4m-4 2c-3.308 0-6 2.692-6 6 0 3.309 2.692 6 6 6 3.309 0 6-2.691 6-6 0-3.308-2.691-6-6-6m5.495.196A7.97 7.97 0 0 1 18 12a7.97 7.97 0 0 1-2.505 5.804l.233-.065C18.196 16.994 20 14.706 20 12c0-2.791-1.919-5.137-4.505-5.804m-3.202 3.097a.999.999 0 1 1 1.414 1.414l-4 4a.997.997 0 0 1-1.414 0l-2-2a.999.999 0 1 1 1.414-1.414L9 12.586Z"
})));
export default SvgGemTasks;